module.exports = __webpack_public_path__ + "static/img/walmart.67034a05.jpg";